import UserAvatar from "@/components/shared/UserAvatar";
import { Button } from "@/components/primitives/button";
import { useToast } from "@/hooks/useToast";

import { acceptJoinRequest, denyJoinRequest } from "@/middleware/chats";

import { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  chatId: string;
  chatName: string;
  username: string;
};

export default function NotificationsListItem({
  chatId,
  chatName,
  username,
}: Props) {
  const { t } = useTranslation();

  const { toast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleDenyUserRequest = async () => {
    try {
      setLoading(true);
      await denyJoinRequest(chatId, username);
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAcceptUserRequest = async () => {
    try {
      setLoading(true);
      await acceptJoinRequest(chatId, username);
      toast({
        duration: 1500,
        description: t("joinRequest.accepted"),
      });
    } catch (error) {
      toast({
        duration: 1000,
        description:
          error instanceof Error ? error.message : t("errorOccurred"),
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-start gap-3 px-4 py-2 align-middle">
        <UserAvatar username={username} className="size-10" />
        <div className="flex flex-col">
          <div className="flex items-center gap-1 truncate">
            <span className="truncate text-lg font-bold">{username}</span>
            <span className="text-sm text-foreground/50">
              {t("isRequestingAccessTo")}
            </span>
          </div>

          <span className="truncate text-sm text-secondary">{chatName}</span>
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 px-4 py-2">
        <Button disabled={loading} onClick={handleAcceptUserRequest}>
          {t("accept")}
        </Button>
        <Button
          disabled={loading}
          onClick={handleDenyUserRequest}
          variant="outline"
        >
          {t("deny")}
        </Button>
      </div>
    </div>
  );
}
